var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.lang)?_c('div',{staticClass:"language-flag shrink-0 px-0.5 py-0 rounded bg-white mr-2 inline-block"},[_c('img',{staticClass:"flag w-5 rounded",attrs:{"alt":_vm.lang,"src":_vm.getImageUrl({ url: `/assets/img/flags/${_vm.language}.png` })}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }